import { native } from '@forest/native-services'
import { createSignal } from 'solid-js'
import { m } from '~/paraglide/messages'
import { CheckIcon, CopyIcon } from './icons'
import { ProgressiveBlur } from './progressive-blur'

export function BottomCta(props: { code: string }) {
  const [copied, setCopied] = createSignal(false)
  let resetTimer: ReturnType<typeof setTimeout> | undefined

  async function copyCode() {
    void native.general.logEvent({
      event_name: 'component_event',
      event_params: {
        type: 'btn',
        app_action: 'click',
        component_name: 'copy_c2c_referral_code',
      },
    })
    try {
      await navigator.clipboard.writeText(props.code)
    } catch {
      // clipboard can reject (permissions / insecure context); still flash
      // the confirmation so the tap feels responsive.
    }
    setCopied(true)
    clearTimeout(resetTimer)
    resetTimer = setTimeout(() => setCopied(false), 1500)
  }

  return (
    <div
      class="fixed inset-x-0 bottom-0 z-20 min-w-[320px] px-7 pt-6"
      style={{
        'padding-bottom': 'calc(max(var(--safe-area-bottom), 24px) + 12px)',
      }}
    >
      <ProgressiveBlur strong="bottom" maxBlur={18} />
      <div class="absolute inset-0 bg-gradient-to-b from-transparent via-[#98c2b4]/50 to-[#176361]/50" />

      <div class="relative z-10 mx-auto flex w-full max-w-[640px] flex-col items-center gap-2">
        <button
          type="button"
          onClick={copyCode}
          aria-label="Copy invite code"
          class="flex h-[52px] w-full items-center justify-center gap-2 rounded-full bg-white text-base font-bold text-cta shadow-[0_0_20px_6px_rgba(198,255,205,0.14)] transition-colors duration-150 active:bg-tertiary-press"
        >
          <span>{props.code}</span>
          {copied() ? (
            <CheckIcon class="size-5 text-cta" />
          ) : (
            <CopyIcon class="size-5 text-cta" />
          )}
        </button>

        {/* TODO: the share button is cut from this version; when it returns,
            log on tap: { event_name: 'component_event', event_params:
            { type: 'btn', app_action: 'click',
              component_name: 'share_c2c_referral' } } */}

        <p class="text-center text-sm font-bold text-white [text-shadow:0_0_5px_rgba(255,255,255,0.65)]">
          {m.invite_footer_all()}
        </p>
      </div>
    </div>
  )
}
